import React, { useState, useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Error from "../../component/Error/Error";
import { apiCall } from "../../helpers/api";

const ResendEmail = () => {
    const { otp } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [errors, setErrors] = useState({});
    const email = useRef();

    const handleResendEmail = (e) => {
        e.preventDefault();

        console.log(email.current?.value);
        const params = {
            path: `resend-email`,
            method: "POST",
            data: {
                email: email.current?.value,
            },
        };

        dispatch(apiCall(params))
            .then((response) => {
                if (response.success) {
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    //   useEffect(() => {
    //     verifyEmail();
    //   }, []);

    return (
        <div className="container">
            <div className="row vh-100 d-flex justify-content-center align-items-center">
                <div className="card w-50">
                    <div className="card-header">Verify your account</div>
                    <div className="card-body">
                        <p className="card-text">We have email you a verification code, if you didn't received an email so please click on resend button to get email again:</p>
                        <form onSubmit={handleResendEmail}>
                            <input ref={email} name="email" type="hidden" value={window.localStorage.getItem("verify-email")} />
                            <h4 className="mb-2">{window.localStorage.getItem("verify-email")}</h4>
                            <button type="submit" className="btn btn-info mt-2">
                                Resend
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResendEmail;
